module.exports = __webpack_public_path__ + "static/media/Nguyen_Trong_Tung.6512806b.jpg";